import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { EnvironmentService } from "./environment.service";

export interface EikosRequestOptions {
  observe?: "body";
  reportProgress?: boolean;
  responseType?: "json";
  withCredentials?: boolean;
}

/**
 * HTTP client for Eikos insurance broker API.
 * Base URL from environment: eikos_api.url
 */
@Injectable({
  providedIn: "root",
})
export class HttpEikosClientService {
  private authHeaders: { headers: HttpHeaders } | null = null;

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  private get endpoint(): string {
    return this.environmentService.get("eikos_api.url") || "";
  }

  private ensureAuthHeaders(): { headers: HttpHeaders } {
    if (!this.authHeaders) {
      const access_token = localStorage.getItem("access_token");
      this.authHeaders = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + access_token,
        }),
      };
    }
    return this.authHeaders;
  }

  /** GET with optional body (Eikos API uses GET + body for brands/subbrands/versions) */
  public get(url: string, body?: unknown, options: EikosRequestOptions = {}): Observable<unknown> {
    const allOpts = { ...this.ensureAuthHeaders(), ...options };
    return this.http.request<unknown>("GET", this.endpoint + url, {
      ...allOpts,
      body: body ?? null,
    });
  }

  public post(url: string, body: unknown, options: EikosRequestOptions = {}): Observable<unknown> {
    const allOpts = { ...this.ensureAuthHeaders(), ...options };
    return this.http.post(this.endpoint + url, body, allOpts);
  }
}
